import React from "react";

import { TitleBarItem } from "../../../../components/UI/ListView";

import {
  ACTIVE,
  ACTIVE_CONF_ADMIN,
  ACTIVE_CONF_PROVIDER,
  ADMIN,
  ARCHIVED,
  ARCHIVED_CONF_ADMIN,
  ARCHIVED_CONF_PROVIDER,
  PENDING,
  PENDING_CONF_ADMIN,
  PENDING_CONF_PROVIDER,
  PROVIDER,
} from "./constants";

const TitleBarItems = (props) => {
  const { source, status } = props;
  let selectedConf;

  if (source === PROVIDER && status === ACTIVE) {
    selectedConf = ACTIVE_CONF_PROVIDER;
  } else if (source === PROVIDER && status === PENDING) {
    selectedConf = PENDING_CONF_PROVIDER;
  } else if (source === ADMIN && status === ACTIVE) {
    selectedConf = ACTIVE_CONF_ADMIN;
  } else if (source === ADMIN && status === PENDING) {
    selectedConf = PENDING_CONF_ADMIN;
  } else if (source === PROVIDER && status === ARCHIVED) {
    selectedConf = ARCHIVED_CONF_PROVIDER;
  } else if (source === ADMIN && status === ARCHIVED) {
    selectedConf = ARCHIVED_CONF_ADMIN;
  }

  return selectedConf.map((titleConf, i) => {
    return (
      <TitleBarItem
        alignCenter={titleConf.center}
        classes={titleConf.colValue}
        key={`${titleConf.listTitleText}-${i}`}
        text={titleConf.listTitleText}
      />
    );
  });
};

export default TitleBarItems;
